import {bp} from './namespace.js';

$.extend(true, bp, {
  state: (function () {
    var state = undefined;
    var changed = [];
    var opts = {
      initial_state: {},
      allowed_parameters: [],
      pretty_url: {
        hidden_values: {},
        excluded_parameters: ['filtered_markers'],
      },
    };

    function _object_to_querystring(obj, prefix) {
      var str = [];
      for (var p in obj) {
        var k = prefix ? prefix + '[' + p + ']' : p;
        var v = obj[p];
        str.push(typeof v == 'object' ?
          _object_to_querystring(v, k) :
          encodeURIComponent(k) + '=' + encodeURIComponent(v));
      }
      return str.join('&');
    }

    function _querystring_to_object() {
      var querystring = (History.getState().cleanUrl.split('?')[1] !== undefined ? History.getState().cleanUrl.split('?')[1] : '');
      var a = querystring.split('&');

      if (a === '') return {};
      var b = {};
      for (var i = 0; i < a.length; ++i) {
        var p = a[i].split('=');
        if (p.length !== 2) continue;
        b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '));
      }
      return b;
    }

    return {
      init: function (custom_opts) {
        custom_opts = typeof custom_opts !== 'undefined' ? custom_opts : {};
        $.extend(true, opts, custom_opts);
        // BPCOM-1716: assign the merged object. `$.extend(true, state, ...)`
        // with `state` still undefined returned a new object without storing
        // it, so `initial_state` was silently discarded and the first
        // bp.state.get()/set() call fell back to a lazy update_from_url().
        state = $.extend(true, {}, opts.initial_state, _querystring_to_object());

        $(window).on('statechange', function () {
          console.debug('statechange');
        });
      },
      get_full_url: function (extra) {
        extra = typeof extra !== 'undefined' ? extra : {};
        let currentState = bp.search.search_form_state();
        let obj = $.extend({}, currentState, extra);
        return new URLSearchParams(obj).toString();
      },
      get_full_url_legacy: function (extra) {
        extra = typeof extra !== 'undefined' ? extra : {};
        return _object_to_querystring($.extend({}, state, extra));
      },
      update_from_url: function () {
        console.debug('update from url');
        var old_state = $.extend({}, state);

        state = $.extend(true, {}, opts.pretty_url.hidden_values, _querystring_to_object());
        changed = [];
        for (var parameter_name in state) {
          if ($.inArray(parameter_name, opts.allowed_parameters) === -1) {
            delete state[parameter_name];
          } else if (state[parameter_name] !== old_state[parameter_name]) {
            changed.push(parameter_name);
          }
        }
        bp.state.updateSessionUrl();
        $(window).trigger('bp-statechange');
      },
      exclude_from_pretty_url: function (hidden_parameters, append) {
        append = append && typeof append === 'boolean';
        if (append === true) {
          opts.pretty_url.excluded_parameters.push.apply(opts.pretty_url.excluded_parameters, hidden_parameters);
        } else {
          opts.pretty_url.excluded_parameters = hidden_parameters;
        }
      },
      history_push: function (updated_arguments) {
        var url_arguments = $.extend({}, _querystring_to_object(), updated_arguments);

        for (var parameter_name in url_arguments) {
          if (
            $.inArray(parameter_name, opts.allowed_parameters) === -1 ||
            $.inArray(parameter_name, opts.pretty_url.excluded_parameters) >= 0 ||
            opts.pretty_url.hidden_values[parameter_name] === url_arguments[parameter_name]
          ) {
            delete url_arguments[parameter_name];
          }
        }

        for (const [key, value] of Object.entries(url_arguments)) {
          if ($.isArray(value)) {
            url_arguments[key] = value.join();
          }
        }

        var title = document.title;
        var objs = _object_to_querystring(url_arguments);
        var url;
        if (objs === '') {
          url = '';
        } else {
          url = '?' + _object_to_querystring(url_arguments);
        }

        History.pushState(null, null, url);
        document.title = title;
        if (typeof ga === 'function') {
          ga('send', 'pageview');
        }
      },
      history_replace: function (updated_arguments) {
        var url_arguments = $.extend({}, _querystring_to_object(), updated_arguments);
        for (var parameter_name in url_arguments) {
          if (
            $.inArray(parameter_name, opts.allowed_parameters) === -1 ||
            $.inArray(parameter_name, opts.pretty_url.excluded_parameters) >= 0 ||
            opts.pretty_url.hidden_values[parameter_name] === url_arguments[parameter_name]
          ) {
            delete url_arguments[parameter_name];
          }
        }
        History.replaceState(null, document.title, '?' + _object_to_querystring(url_arguments));
      },
      set: function (parameter_name, parameter_value) {
        if (state === undefined) {
          this.update_from_url();
        }
        state[parameter_name] = parameter_value;
      },
      get: function (parameter_name) {
        if (state === undefined) {
          this.update_from_url();
        }
        return parameter_name = typeof parameter_name !== 'undefined' ? state[parameter_name] : state;
      },
      value_changed: function (parameter_name) {
        return ($.inArray(parameter_name, changed) >= 0);
      },
      updateSessionUrl: function () {
        const url = window.location.pathname + window.location.search;
        $.ajax({
          method: 'POST',
          url: '/update_session_url/',
          data: {url: url},
        });
      },
    };
  })(),
});

export {bp};
